/**
 * Component to highlight specific words in a sentence.
 *
 * @param {string} props.sentence - The sentence in which words will be highlighted.
 * @param {string} [props.className] - Optional class name for the component.
 * @param {React.CSSProperties} [props.style] - Optional inline styles for the component.
 * @param {React.CSSProperties} [props.highlightStyle] - Optional inline styles for the highlighted words.
 * @param {number[]} [props.highlightIndicesList] - Optional list of indices of words to be highlighted.
 * @param {string[]} [props.highlightBgList] - Optional list of background images for the highlighted words.
 * @returns {JSX.Element} The rendered HighlightWordsComponent.
 */
import React from "react";
import { HighlightWordsComponentProps } from "../../constants/interface";

// Component to highlight specific words in a sentence
const HighlightWordsComponent = (props : HighlightWordsComponentProps) => {
    const { 
        sentence,
        className,
        style,
        highlightStyle = {
            textDecoration: 'underline',
            textDecorationThickness: '4px',
            fontWeight: '400',
        },
        highlightList,
    } = props;

    // Split the sentence into words
    const words = sentence?.split(" ") || [];
    
    let backgroundImageStyle = {
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'inline-block',
        padding: '1rem',
    };

    return (
        <p className={className} style={style}>
        {words.map((word: string, index: number) =>
            (highlightList?.[index]) ? (
                <span key={index} style={{
                    ...highlightStyle,
                    /* Add background image & styles */
                    ...backgroundImageStyle,
                    backgroundImage: `url(${highlightList[index]})` 
                }}>
                    {word}{" "}
                </span>
            ) : (
                <span key={index}>{word} </span>
            )
        )}
        </p>
    );
};

export default HighlightWordsComponent;
